/**
 * Fallback values for the Statsig-managed Get Started carousel content.
 * The active values are configured in the get_started_carousel dynamic config.
 * The For You onboarding tutorial row also uses the tutorial fallback values.
 *
 * Ordered array of catalog GUIDs.
 */
export const ONBOARDING_TUTORIAL_GUIDS: string[] = [
  "398895dc-51bc-4b73-bc6d-d0a10c3b53b5", // Cisco U. 101: Dashboard
  "7ab1d787-7fda-4559-92fd-27912ee1ff92", // Cisco U. 101: Community Tutorial
  "05d39d27-9c10-4ef4-a3cc-7f5b0b2572c7", // Cisco U. 101: For You and Learning Paths
  "3c8b9033-6627-4f7f-a38e-7e6c887369a4", // Cisco U. 101: Learn Like a Pro
];

// The /tracks endpoint retrieves one video series and its child videos per request.
export const ONBOARDING_VIDEO_TRACK_GUID = "1e1451f4-e0b4-42bf-ab02-965b92f172c1";

export default ONBOARDING_TUTORIAL_GUIDS;
